
import * as THREE from "../../../../libs/three.js/build/three.module.js";

import math from "../../utils/math.js"; 








let planeGeo = new THREE.PlaneGeometry(1.6, 1.6, 1, 1)
let texLoader = new THREE.TextureLoader()  

var lastQ = new THREE.Quaternion()


export class FloorCompass extends THREE.Object3D{
    
    
    constructor(viewer){
        super()
        this.angle = 0
        this.build()
        Potree.Utils.updateVisible(this,'isAtPano',false)
        viewer.scene.scene.add(this) 
        
        viewer.addEventListener('camera_changed', e => { 
            if(e.viewport == viewer.mainViewport && e.changeInfo.quaternionChanged ){  
                 this.updateRot()
            }
        })
        let init = ()=>{
            let setPano = (pano)=>{ 
                this.position.copy(pano.floorPosition)
                this.position.z += 0.05
                Potree.Utils.updateVisible(this,'isAtPano',true)
            }
            if(viewer.images360.currentPano){
                setPano(viewer.images360.currentPano)
            } 
            viewer.images360.addEventListener('flyToPano', e => { 
                //console.log('floorcompass set pano',e.toPano.pano.id) 
                setPano(e.toPano.pano)
            })
        }
        if(viewer.allLoaded){
            init()
        }else{
            viewer.addEventListener('allLoaded',e=>{
                init()
            })
        }
        
        this.addEventListener('isVisible',e=>{//visi change
            if(this.visible)this.updateRot()
            viewer.dispatchEvent('content_changed')    
        })
        
    }
    
    
    
    build(){ 
           
        let count = 0
        let loaded = tex => {
            count++
            if (count == 2) { 
             
                this.underLayer = new THREE.Mesh(
                    planeGeo,
                    new THREE.MeshBasicMaterial({
                        map: compassMap,
                        transparent: true,
                        side: THREE.SingleSide,
                        depthTest: false,
                    })
                )
                this.underLayer.name = 'underLayer' 
                this.underLayer.renderOrder = 2
            
                this.arrow = new THREE.Mesh(
                    planeGeo,
                    new THREE.MeshBasicMaterial({
                        map: arrowMap,
                        transparent: true,
                        side: THREE.SingleSide,
                        depthTest: false,
                    })
                )
                this.arrow.name = 'compassArrow' 
                this.arrow.position.set(0, 0, 0.01)  
                this.arrow.renderOrder = 3
                this.add(this.underLayer)  
                this.add(this.arrow) 
                this.updateRot()
                //this.setAngle()  
                //done && done()
            }
        }
        
        
        let arrowMap = texLoader.load(Potree.resourcePath+'/textures/compass_arrow.png', loaded)
        let compassMap = texLoader.load(Potree.resourcePath+'/textures/compass_floor.png', loaded) 
     
    }
    
    
    setAngle(angle){
        if(angle === this.angle ) return 
        this.angle = angle
        this.rotation.set(0, 0, -THREE.Math.degToRad(angle))  
        viewer.dispatchEvent('content_changed')
    }
    
    updateRot() {
        
      
        /* rotation = new THREE.Euler(0, 0, yaw - this.firstLogo.rotation.z)
        this.compassArrow1.rotation.copy(rotation) */
        if(!this.arrow || !this.visible)return
        this.arrow.rotation.z = viewer.mainViewport.view.yaw - this.rotation.z
               
       
        
    }
    
   
    
}

 